import * as React from 'react';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { useTheme } from '@mui/system';
import { formatDateTime, formatThaiShortDateTwoDigitYear } from 'common/utils/date';

type Props = {
	farm_name: string;
	title: string;
	body?: string;
	created_at?: string;
	read_at?: string | null;
	lines?: number;
};

export default function NotificationCard({ farm_name, title, body, created_at, read_at, lines }: Props) {
	const theme = useTheme();
	return (
		<Paper
			elevation={0}
			sx={{
				fontSize: 13,
				p: 2,
				borderRadius: 2,
				border: '1px solid',
				borderColor: 'divider',
				mb: 0,
				width: '100%',
				bgcolor: 'background.paper',
			}}
		>
			<Box display="flex" gap={2} flexDirection="column" alignItems="flex-start">
				<Box display="flex" flexDirection="row" alignItems="center" gap={1}>
					{read_at ? null : (
						<Box
							sx={{
								width: 12,
								height: 12,
								borderRadius: '50%',
								bgcolor: theme.palette.error.main,
								mt: 0.5,
							}}
						/>)}
					{farm_name && (
						<Typography variant="caption" sx={{ mt: 1, color: 'text.secondary', textAlign: 'center' }}>
							{farm_name}
						</Typography>
					)}
				</Box>
				<Box>
					<Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
						{title}
					</Typography>
					{body && (
						<>
							<Typography
								variant="body2"
								sx={{
									color: 'text.secondary',
									mt: 0.5,
									...(typeof lines === 'number' && lines > 0
										? {
											display: '-webkit-box',
											WebkitLineClamp: lines,
											WebkitBoxOrient: 'vertical',
											overflow: 'hidden',
											textOverflow: 'ellipsis',
										}
										: {}),
								}}
							>
								{body}
							</Typography>
						</>
					)}
				</Box>
				<Box>
					<Typography variant="caption" sx={{ color: 'text.secondary' }}>
						{formatThaiShortDateTwoDigitYear(created_at ?? '', { showTime: true })}
					</Typography>
				</Box>
			</Box>
		</Paper>
	);
}
